import React from "react";
import {
  makeStyles,
  tokens,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbButton,
  BreadcrumbDivider,
} from "@fluentui/react-components";
import { Home24Regular } from "@fluentui/react-icons";
import {
  BreadcrumbItem as BreadcrumbItemType,
  DimensionType,
  DIMENSION_LABELS,
} from "../types";
import { DimensionSelector } from "./DimensionSelector";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: tokens.spacingHorizontalS,
    //padding: tokens.spacingVerticalM,
    //backgroundColor: tokens.colorNeutralBackground3,
    //borderRadius: tokens.borderRadiusMedium,
    //border: `1px solid ${tokens.colorNeutralStroke2}`,
  },
  dimensionSelector: {
    display: "flex",
    alignItems: "center",
  },
});

interface BreadcrumbBarProps {
  items: BreadcrumbItemType[];
  currentDimension: DimensionType;
  onDimensionChange: (dimension: DimensionType) => void;
  onNavigate: (index: number) => void;
  onClearAll: () => void;
}

export const BreadcrumbBar: React.FC<BreadcrumbBarProps> = ({
  items,
  currentDimension,
  onDimensionChange,
  onNavigate,
  onClearAll,
}) => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <Breadcrumb aria-label="Filter breadcrumb">
        <BreadcrumbItem>
          <BreadcrumbButton icon={<Home24Regular />} onClick={onClearAll}>
            All
          </BreadcrumbButton>
        </BreadcrumbItem>

        {items.map((item, index) => (
          <React.Fragment key={`${item.dimension}-${item.value}-${index}`}>
            <BreadcrumbDivider />
            <BreadcrumbItem>
              <BreadcrumbButton onClick={() => onNavigate(index)}>
                {DIMENSION_LABELS[item.dimension]}: {item.label}
              </BreadcrumbButton>
            </BreadcrumbItem>
          </React.Fragment>
        ))}

        <BreadcrumbDivider />
        <BreadcrumbItem>
          <div className={styles.dimensionSelector}>
            <DimensionSelector
              value={currentDimension}
              onChange={onDimensionChange}
              size="small"
            />
          </div>
        </BreadcrumbItem>
      </Breadcrumb>
    </div>
  );
};
